import { api } from '@/apps/@utils';
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const BindingContext = createContext();

const BindingProvider = ({ children }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [from, setFrom] = useState('');
  const [rawPayload, setRawPayload] = useState('');
  const [payload, setPlayload] = useState({});
  const [bindingId, setBindingId] = useState(null);
  const [mounted, setMounted] = useState(false);
  
  const clear = useCallback(() => {
    setFrom('');
    setRawPayload('');
    setPlayload({});
  }, []);

  useEffect(() => {
    const paramsFrom = searchParams.get('from');
    if (paramsFrom) {
      setFrom(paramsFrom);
    }
    setRawPayload(searchParams.toString());

    const paylaodData = Object.fromEntries(searchParams.entries());
    setPlayload(paylaodData);
    console.log('payload', paylaodData);

    if (!paramsFrom) {
      setMounted(true);
      return;
    }
    (async () => {
      try {
        const response = await api.post("/binding-log", {
          from: paramsFrom,
          path: window.location.pathname,
          payload: paylaodData, 
        });
        setBindingId(response.data.id);
      } catch (error) {
        console.error(error);
      }
      try {
        if (paylaodData.redirect) {
          await api.post("/check-redirect", { redirect_url: paylaodData.redirect });
        }
      }
      catch (error) {
        console.error(error);
        navigate('/desktop')
      }
      setMounted(true);
    })();
  }, []);
  
  return (
    <BindingContext.Provider 
      value={{
          clear,
          from, 
          rawPayload, 
          payload,
          bindingId,
      }}
    >
      {mounted && children}
    </BindingContext.Provider>
  );
};

// Hook for easier usage
const useBindingContext = () => useContext(BindingContext);

export { BindingProvider, useBindingContext };
